module.exports = __webpack_public_path__ + "img/automation-content.bcf9acdd.png";